import { BellOutlined } from '@ant-design/icons'
import { useQuery } from '@apollo/client'
import { Badge, Button, Col, Dropdown, Layout as AntLayout, Menu, Row, Select } from 'antd'
import { LayoutProps } from 'antd/lib/layout'
import React, { useCallback } from 'react'
import { Link, matchPath, useHistory, useLocation } from 'react-router-dom'
import styled from 'styled-components'
import { COPROPRIETE_ALL } from '../../apollo/query/copropriete.query'
import { COLOR } from '../../constants'
import { useAuth } from '../../lib/hooks'
import { D4_Copropriete } from '../../types'
import D4Avatar from '../D4Avatar'
const { Header: AntHeader } = AntLayout
interface StyledHeaderPops extends LayoutProps {
  $collapsed: boolean
}

const StyledHeader: React.FC<StyledHeaderPops> = styled((props: StyledHeaderPops) => <AntHeader {...props} />)`
  padding: 0;
  background-color: #fff;
  position: fixed;
  top: 0;
  width: ${(props) => (props.$collapsed ? '100%' : 'calc(100% - 200px)')};
  height: 50px;
  margin-left: 0px;
  box-shadow: 0px 1px 5px rgba(0, 0, 0, 0.2);
`

const ProfileMenu = () => {
  const history = useHistory()
  const { signout } = useAuth()
  return (
    <Menu>
      <Menu.Item key="notif" icon={<BellOutlined />}>
        Notifications
      </Menu.Item>
      <Menu.Item key="0">
        <Link to="/profil">Profil</Link>
      </Menu.Item>
      <Menu.Item key="1" onClick={() => signout(() => history.replace('/login'))}>
        Déconnexion
      </Menu.Item>
    </Menu>
  )
}

const Header = ({ collapsed }: { collapsed: boolean }) => {
  const { data } = useQuery<{ managed: D4_Copropriete[]; notManaged: D4_Copropriete[] }>(COPROPRIETE_ALL)
  const { pathname } = useLocation()
  const { push } = useHistory()
  const { user } = useAuth()
  const currentCopro = matchPath<{ trigramme: string }>(pathname, {
    path: '/copropriete/:trigramme/',
    exact: false,
    strict: false,
  })

  const handleSelectCopro = useCallback(
    (copro: string) => {
      if (currentCopro?.params.trigramme) {
        const nextRoute = pathname.split('/')
        nextRoute[2] = copro
        push(nextRoute.join('/'))
      } else {
        push(`/copropriete/${copro}/legacy/index.jsp`)
      }
    },
    [currentCopro?.params.trigramme, pathname, push]
  )

  const options = [...(data?.managed ?? []), ...(data?.notManaged ?? [])].map((copro: D4_Copropriete) => ({
    value: copro.trigramme,
    label: `${copro.trigramme} - ${copro.nom}`,
  }))

  return (
    <StyledHeader $collapsed={collapsed}>
      <Row
        style={{ backgroundColor: COLOR.white, height: '100%', lineHeight: 0 }}
        justify="space-between"
        align="middle"
      >
        <Col xs={{ offset: 3 }} sm={{ offset: 2 }} xl={{ offset: 1 }}>
          <Select
            placeholder="Recherche"
            showSearch
            value={currentCopro?.params.trigramme || undefined}
            //@ts-expect-error
            options={options}
            style={{ width: '200px' }}
            onSelect={handleSelectCopro}
          />
        </Col>
        <Col>
          <Col>
            <Row gutter={12} justify="end" align="middle">
              <Col>
                <Dropdown overlay={<ProfileMenu />} placement="bottomLeft">
                  <Badge showZero count={5} offset={[-40, 10]}>
                    <Button
                      size="large"
                      icon={
                        <D4Avatar
                          role={user?.profil?.toLocaleLowerCase()}
                          nom={user?.personne?.nom}
                          prenom={user?.personne?.prenom}
                          noTooltip
                        />
                      }
                      type="text"
                    />
                  </Badge>
                </Dropdown>
              </Col>
            </Row>
          </Col>
        </Col>
      </Row>
    </StyledHeader>
  )
}

export default Header
